var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.5,
    height: 14.5,
    viewBox: "0 0 17.5 14.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "photo-camera",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M15.506,43.6H12.627l-.371-1.819A.994.994,0,0,0,11.279,41H5.721a.994.994,0,0,0-.977.785L4.373,43.6H1.494A1.482,1.482,0,0,0,0,45.07v8.465A1.482,1.482,0,0,0,1.494,55H15.506A1.482,1.482,0,0,0,17,53.535V45.07A1.482,1.482,0,0,0,15.506,43.6ZM5.721,41.977h5.558l.332,1.628H5.389ZM16,53.535a.494.494,0,0,1-.5.488H1.494a.494.494,0,0,1-.5-.488V45.07a.494.494,0,0,1,.5-.488H15.506a.494.494,0,0,1,.5.488Z",
    transform: "translate(0 -41)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M148.688,185a3.688,3.688,0,1,0,3.688,3.688A3.692,3.692,0,0,0,148.688,185Zm0,6.379a2.691,2.691,0,1,1,2.691-2.691A2.694,2.694,0,0,1,148.688,191.379Z",
    transform: "translate(-140.188 -180.501)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M67.093,185H65.5a.5.5,0,0,0,0,1h1.595a.5.5,0,0,0,0-1Z",
    transform: "translate(-62.841 -180.319)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.d028c479d6866930645ddb7d6c513626.svg";
export { ForwardRef as ReactComponent };